(ns common.security.pem
  (:require [clojure.string :as string]))

(defn format-pem-line-breaks [pem]
  (let [pem (-> pem
                (str)
                (string/replace #"[\r\n]" ""))]
    (->> pem
         ;; https://www.rfc-editor.org/rfc/rfc1421 - 4.3.2.4 each line but last should be 64 chars
         (re-seq #".{1,64}")
         (string/join "\n"))))
